// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper {
  background: #fff;
  font-family: "Source Sans Pro";
}
.wrapper form {
  padding: 2rem 0;
  max-width: 1200px;
  margin: auto;
  color: #5d5f63;
}
.wrapper form .form-group {
  margin: 2rem 0;
  padding-bottom: 2rem;
  border-bottom: 1px solid #eee;
}
.wrapper form .pull-top {
  margin-top: -0.5em;
  display: block;
}
.wrapper form .col-form-label {
  text-align: right;
  font-weight: bold;
}
.wrapper form .gutter-right {
  padding-right: 1rem;
}
.wrapper form .send {
  text-transform: uppercase;
  padding: 0.5rem 6rem;
}
.wrapper form .send:disabled {
  background: #ccc;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
